import { defineManifest } from '@template/modules'

export default defineManifest({
  id: 'support',
  name: 'Suporte',
  description: 'Sistema de tickets com mensagens, SLA e satisfacao',
  version: '1.0.0',
  category: 'optional',
  enabled: false,
  order: 20,
  dependencies: ['auth', 'notifications'],
  routes: ['/support', '/support/tickets', '/support/tickets/new'],
  apiRoutes: ['/api/support'],
  requiredTables: ['support_tickets', 'support_messages'],
  envVars: [],
  featureFlags: ['module.support'],
  hooks: ['useSupportTickets', 'useSupportMessages'],
  components: [
    'TicketCard',
    'TicketStatusBadge',
    'TicketPriorityIndicator',
    'ConversationThread',
    'MessageInput',
    'SatisfactionRating',
    'TicketActions',
  ],
  icon: 'HelpCircle',
  path: '/support',
  roles: [],
  showInSidebar: true,
  group: 'Suporte',
  functions: [
    {
      id: 'support-hub',
      moduleId: 'support',
      name: 'Central de Suporte',
      subtitle: 'Visao geral do suporte',
      path: '/support',
      category: 'OPERACIONAL',
      enabled: true,
      order: 0,
      roles: [],
      tags: ['suporte'],
    },
    {
      id: 'support-tickets',
      moduleId: 'support',
      name: 'Tickets',
      subtitle: 'Gerenciar tickets',
      path: '/support/tickets',
      category: 'OPERACIONAL',
      enabled: true,
      order: 1,
      roles: [],
      tags: ['tickets', 'suporte'],
    },
    {
      id: 'support-new',
      moduleId: 'support',
      name: 'Novo Ticket',
      subtitle: 'Abrir ticket de suporte',
      path: '/support/tickets/new',
      category: 'OPERACIONAL',
      enabled: true,
      order: 2,
      roles: [],
      tags: ['ticket', 'novo'],
    },
  ],
})
